// Alignment enums
export const enum HorizontalAlign {
  CENTER = "center",
  LEFT = "left",
  RIGHT = "right",
}
